import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ViemoPlayer from './components/Video.vue';

import ScrollReveal from 'scrollreveal';
import MultiLingual from 'multilingual.js';
import Player from '@vimeo/player';
import mapboxgl from 'mapbox-gl';
import Chart from 'chart.js/auto';

const app = createApp(App);

app.config.globalProperties.mapboxgl = mapboxgl;
app.config.globalProperties.ScrollReveal = ScrollReveal;
app.config.globalProperties.Chart = Chart;

app.config.globalProperties.MultiLingual = function (selector) {
    new MultiLingual({
        containers: document.querySelectorAll(selector),
        configuration: ['ko', 'en', 'num', 'punct'],
    });
};
app.config.globalProperties.Player = Player;

app.component('video-player', ViemoPlayer);

app.use(router);
app.mount('#app');
